// Admin-side keys. Note @tempmee/awards exports a `bidKeys` factory, but that
// covers the consumer apps (history, EOD gate, pending feedback) — not admin.

// The client omits falsy filter values before sending, so { search: '' } and {}
// produce the same HTTP request. Stripping them from the key too lets hooks that
// happen to query the same endpoint (e.g. useCycleMembershipCount with {} and
// useGetCycleMemberships with the default { search: '', ... }) share a single
// React Query cache entry instead of firing duplicate requests.
const stripEmptyFilters = (filters) => {
  if (!filters) return {};
  const out = {};
  if (filters.search) out.search = filters.search;
  if (filters.userType) out.userType = filters.userType;
  if (filters.status) out.status = filters.status;
  return out;
};

// True when any roster filter is set. Derived from the same falsy-stripping rule
// as the query key above, so "which fields count as a filter" lives in one place:
// add a field to stripEmptyFilters and both the cache key and this predicate
// follow, instead of a caller re-listing the keys and drifting (GOTU-6400).
export const hasActiveFilters = (filters) =>
  Object.keys(stripEmptyFilters(filters)).length > 0;

export const awardsKeys = {
  all: ['awards'],
  cycles: (page) => ['awards', 'cycles', page],
  cycle: (id) => ['awards', 'cycle', id],
  // Matches every memberships query for a cycle regardless of filters or page.
  // Invalidation code should use this rather than hand-writing the literal.
  membershipsPrefix: (cycleId) => ['awards', 'cycle', cycleId, 'memberships'],
  memberships: (cycleId, filters, page) => [
    ...awardsKeys.membershipsPrefix(cycleId),
    stripEmptyFilters(filters),
    page,
  ],
};
